var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.833,
    height: 84.314,
    viewBox: "0 0 50.833 84.314",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6130",
    "data-name": "Group 6130",
    transform: "translate(9572.672 8412.314)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M59.6,72.285c-3.785-.052-7.569-.136-11.354-.146-3.841-.009-6.587-1.549-7.57-4.8a8.716,8.716,0,0,1,2.215-9.083C52.76,47.826,62.524,37.279,72.34,26.791c3.333-3.561,7.854-3.782,10.562-.576,3.024,3.581,2.738,7.978-.8,11.765q-8.318,8.906-16.657,17.788c-.511.546-.979,1.141-1.581,1.846,4.361.059,8.461.1,12.56.175,3.023.052,4.552,2.31,6.764,4.994,2.041,2.477.382,6.336-1.907,8.65-3.09,3.123-6.223,6.2-9.786,9.734,3.636,3.918,6.8,7.3,9.943,10.721,4.23,4.6,3.3,10.887-1.935,13.262-2.653,1.2-5.514.533-7.7-1.912Q64.463,95.014,57.17,86.732a7.988,7.988,0,0,1,.088-11.1c.849-.96,1.787-1.824,2.684-2.733l-.338-.611",
    transform: "translate(-9609.47 -8434.229)",
    fill: "#DFDFDE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M184.091,427.583l22.19-22.6a1.883,1.883,0,0,1,2.7,0l7.746,7.89a1.969,1.969,0,0,1,0,2.748l-22.19,22.6a1.883,1.883,0,0,1-2.7,0l-7.746-7.89a1.969,1.969,0,0,1,0-2.748",
    transform: "translate(-9740.563 -8782.259)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M395.763,819.231a7.325,7.325,0,0,1,9.052-5.178,7.5,7.5,0,0,1,5.084,9.22,7.324,7.324,0,0,1-9.052,5.178,7.5,7.5,0,0,1-5.084-9.22",
    transform: "translate(-9934.453 -9156.73)",
    fill: "#B7CDC8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M50.285,11.2,10.995,51.217a1.852,1.852,0,0,1-2.653,0L.55,43.281a1.936,1.936,0,0,1,0-2.7L39.84.559a1.852,1.852,0,0,1,2.653,0L50.285,8.5a1.936,1.936,0,0,1,0,2.7",
    transform: "translate(-9572.673 -8412.314)",
    fill: "#239281"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlex);
export default __webpack_public_path__ + "static/media/flex.9812ce45642abfac905d844345a4b932.svg";
export { ForwardRef as ReactComponent };